import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import Sunset from './pages/Sunset.tsx';
import { GlobalErrorBoundary } from '@/components/ui/error-boundary';
import { initSentry } from '@/lib/sentry';
import { initPostHog } from '@/lib/posthog';
import './index.css';

// Auto-reload when lazy-loaded chunks are missing after a new deployment.
// Vite emits this event when a dynamic import fails (e.g. the old hashed
// chunk was replaced). We reload once to pick up the new assets.
window.addEventListener('vite:preloadError', () => {
  const reloadedKey = 'chunk-reload';
  if (!sessionStorage.getItem(reloadedKey)) {
    sessionStorage.setItem(reloadedKey, '1');
    window.location.reload();
  }
});

const isPocoSunsetMode = import.meta.env.VITE_POCO_SUNSET_MODE === 'true';

if (!isPocoSunsetMode) {
  initSentry();
  initPostHog();
}

createRoot(document.getElementById('root')!).render(
  isPocoSunsetMode ? (
    <Sunset />
  ) : (
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  ),
);
